import { CAlert } from '@coreui/react'
import React from 'react'
import { Field } from 'react-final-form'
import { renderFieldForm } from '../helpers/column/Pemakaian/Tambah'

/** 
 *
 * @Description
 * Berguna untuk keperluan update form
 * @Params
 */
const must_type = ["checkbox"]

export const updateDataForm = (
  form = [],
  data,
  method,
  is_form_disabled = [],
  accessor = ['id_layanan'],
) => {
  let _form = form
  // const accessor = ['id_layanan']

  const form_disabled = method === 'edit' ? is_form_disabled : []

  function genContent(content, data) {
    let _content = content.map((sItem) => ({
      ...sItem,
      ...(accessor.includes(sItem.name) && {
        data: data[sItem.name],
      }),
      ...(form_disabled.includes(sItem.name) && {
        readOnly: true,
      }),
      ...(form_disabled.includes(sItem.name) && {
        validate: null,
      }),
    }))

    return _content
  }
  _form = form.map((item) => {
    return {
      ...item,
      ...(accessor.includes(item.name) && {
        data: accessor.includes(item.name) ? data[item.name] : [],
      }),
      ...(form_disabled.includes(item.name) && {
        validate: null,
      }),
      ...(Array.isArray(item.content) && {
        content: genContent(item.content, data),
      }),
    }
  })

  return _form
}

export const GeneratorForm = ({ form, pop, values, FormArrayName }) => {

  // console.log(form)
  return (
    <React.Fragment>
      {form.map((item, index) => {
        if (item.layOut === 'formGroupVerticalAndLabel' && item.content) {
          return (
            <React.Fragment key={`${index}${item?.name || 'content'}`}>
              <div className="row gx-1">
                {item.content?.map((xContent, xIndex) => (
                  <div
                    className={`col-sm-${12 / item.content.length}`}
                    key={`${xIndex}${xContent?.name}`}
                  >
                    <div className={'mb-1'}>
                      <Field
                        key={xIndex}
                        layOut={xContent.layOut}
                        item={xContent}
                        metatype={xContent.type}
                        name={FormArrayName ? `${FormArrayName}.${xContent.name}` : xContent.name}
                        component={renderFieldForm}
                        size={xContent.size}
                        customRender={xContent.customRender}
                        readOnly={xContent.readOnly}
                        validate={xContent.validate}
                        className={`col-sm-${12 / item.content.length}`}
                        autoFocus={xContent.focus}
                        allowNull={true}
                        parse={(x) => x}
                        allValues={values}
                      // {...(must_type.includes(xContent?.type) && {
                      //   type: xContent.type
                      // })}
                      // type={xContent?.type}

                      />
                    </div>
                  </div>
                ))}
              </div>
            </React.Fragment>
          )
        }

        if (item.content && item.layOut === 'formGroupVerticalAndLabelCalout') {
          return (
            <CAlert color="success mt-1" key={index}>
              <small>{item?.label}</small>
              <br />
              <React.Fragment>
                <div className="row gx-1 mt-2">
                  {item.content?.map((xContent, xIndex) => (
                    <div className={`col-sm-${12 / item.content.length}`} key={xIndex}>
                      <div className={'mb-1'}>
                        <Field
                          key={xIndex}
                          layOut={xContent.layOut}
                          item={xContent}
                          metatype={xContent.type}
                          // type={xContent?.type}
                          // name={xContent.name}
                          name={FormArrayName ? `${FormArrayName}.${xContent.name}` : xContent.name}
                          component={renderFieldForm}
                          customRender={xContent.customRender}
                          readOnly={xContent.readOnly}
                          validate={xContent.validate}
                          className={`col-sm-${12 / item.content.length}`}
                          autoFocus={xContent.focus}
                          allowNull={true}
                          parse={(x) => x}
                        // {...(must_type.includes(xContent?.type) && {
                        //   type: xContent.type
                        // })}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </React.Fragment>
            </CAlert>
          )
        }
        if (item.layOut === 'formGroupHorizontal' && !item.notUseField) {
          return (
            <Field
              validate={item.validate}
              item={item}
              key={index}
              parse={(x) => x}
              metatype={item.type}
              // type={item?.type}
              // name={item.name}
              name={FormArrayName ? `${FormArrayName}.${item.name}` : item.name}
              size={item.size}
              layOut={item.layOut}
              component={renderFieldForm}
              readOnly={item.readOnly}
              autoFocus={item.autoFocus}
              customRender={item.customRender}
              allValues={values}
              allowNull={true}
            // {...(must_type.includes(item?.type) && {
            //   type: item.type
            // })}
            />
          )
        }
        if (item.layOut) {
          return (
            <Field
              validate={item.validate}
              item={item}
              key={index}
              parse={(x) => x}
              metatype={item.type}
              // type={item?.type}
              // name={item.name}
              name={FormArrayName ? `${FormArrayName}.${item.name}` : item.name}
              size={item.size}
              layOut={item.layOut}
              component={renderFieldForm}
              readOnly={item.readOnly}
              autoFocus={item.autoFocus}
              customRender={item.customRender}
              allValues={values}
              allowNull={true}
              {...(must_type.includes(item?.type) && {
                type: item.type
              })}
            />
          )
        }
        if (item.notUseField) {
          return (
            item.customRender && React.cloneElement(item.customRender, { pop, values, key: index, content: item })
          )
        }
        return <div key={index}>Belum Mengisi Layout pilihnanya adalah <strong>[formGroupHorizontal, formGroupVerticalAndLabel ]</strong> </div>
      })}
    </React.Fragment>
  )
}

export const GeneratorPacketRadius = ({ form, showCalculator, values }) => {
  //   console.log(form)
  return (
    <React.Fragment>
      {form.map((item, index) => {
        if (item.content && item.layOut === 'formGroupFe' && showCalculator) {
          return (
            <React.Fragment key={index}>
              <div className="alert alert-primary">
                <div className="row">
                  <div className="col-md-6">
                    <strong>UPLOAD</strong>
                  </div>
                  <div className="col-md-6">
                    <strong>DOWNLOAD</strong>
                  </div>
                </div>
                <div className="row">
                  {item.content?.map((xContent, xIndex) => (
                    <React.Fragment key={xIndex}>
                      {xContent?.data?.map((zItem, zIndex) => (
                        <div className="col-md-6" key={zIndex}>
                          <div className={'mb-1'}>
                            <Field
                              key={zIndex}
                              layOut={zItem.layOut}
                              item={zItem}
                              allValues={values}
                              metatype={zItem.type}
                              name={zItem.name}
                              component={renderFieldForm}
                              parse={(x) => x}
                              allowNull
                              readOnly={zItem.readOnly}
                              validate={zItem.validate}
                              className={`col-${12 / xContent.data.length}`}
                            />
                          </div>
                        </div>
                      ))}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            </React.Fragment>
          )
        }

        if (item.layOut === 'formGroup' && item.content) {
          return (
            <div className="row" key={index}>
              {item.content?.map((xContent, xIndex) => (
                <div className={`col-sm-${12 / item.content.length}`} key={index}>
                  <div className={'mb-1'}>
                    <Field
                      key={xIndex}
                      layOut={xContent.layOut}
                      item={xContent}
                      metatype={xContent.type}
                      name={xContent.name}
                      component={renderFieldForm}
                      customRender={xContent.customRender}
                      readOnly={xContent.readOnly}
                      validate={xContent.validate}
                      className={`col-sm-${12 / item.content.length}`}
                      autoFocus={xContent.focus}
                      parse={(x) => x}
                      allowNull
                    />
                  </div>
                </div>
              ))}
            </div>
          )
        }

        if (item.layOut === 'formGroupHorizontal') {
          return (
            <Field
              validate={item.validate}
              item={item}
              key={index}
              metatype={item.type}
              name={item.name}
              layOut={item.layOut}
              component={renderFieldForm}
              readOnly={item.readOnly}
              parse={(x) => x}
              allowNull
            />
          )
        }
        return <span key={index}></span>
      })}
    </React.Fragment>
  )
}
